<template>
  <div>
    <!--explanation-->
    <div class="col-xs-12">
      <template v-if="Object.keys(settableContexts).length === 1">
        <span style="font-style:italic;">{{ trans('profile.only_one_action') }}</span>
      </template>
    </div>

    <!--settings-->
    <form>
      <div class="form-group col-xs-12">
        <label
          class="control-label col-xs-2"
          style="text-align:right; margin: 0;"
          for="action_1"
        >
          {{ trans('profile.action') + ' 1' }}
        </label>
        <div class="col-xs-8">
          <select
            id="action_1"
            v-model="action_1"
            class="form-control"
            name="action_1"
          >
            <option value="no_action">
              {{ trans('profile.no_action') }}
            </option>
            <option
              v-for="context in settableContexts"
              :value="context"
            >
              <span>{{ trans('attendance_list.contexts.' + context) }}</span>
            </option>
          </select>
        </div>
        <div class="col-xs-2">
          <span :class="getIcon(action_1) + ' fa-2x'" />
        </div>
      </div>

      <div class="form-group col-xs-12">
        <label
          class="control-label col-xs-2"
          style="text-align:right; margin: 0;"
          for="action_2"
        >
          {{ trans('profile.action') + ' 2' }}
        </label>
        <div class="col-xs-8">
          <select
            id="action_2"
            v-model="action_2"
            class="form-control"
            name="action_2"
          >
            <option value="no_action">
              {{ trans('profile.no_action') }}
            </option>
            <option
              v-for="context in settableContexts"
              :value="context"
            >
              <span :class="getIcon(context)">{{ trans('attendance_list.contexts.' + context) }}</span>
            </option>
          </select>
        </div>
        <div class="col-xs-2">
          <span :class="getIcon(action_2) + ' fa-2x'" />
        </div>
      </div>
    </form>

    <!--example-->
    <div class="col-xs-12">
      <div style="font-style:italic; margin-top:20px; margin-bottom:10px;">
        {{ trans('profile.example_registration_settings') }}
      </div>
    </div>

    <div
      class="col-xs-12"
      style="width:100%"
    >
      <div class="row attendance-list-row">
        <div class="col-xs-6">
          <div
            class="awesome-checkbox"
            style="opacity: 0% !important"
          >
            <div
              class="checkbox checkbox-attendance-list"
              style="margin:0px"
            >
              <input
                id="student_example_1"
                type="checkbox"
                class="student_checkbox"
                disabled
              >
              <label for="student_example_1"><span>Student 1</span></label>
            </div>
          </div>
        </div>

        <div class="col-xs-6">
          <span
            class="attendance-icon pull-right fa fa-ellipsis-v fa-lg"
            style="margin-top:10px; padding:0px;"
          />
          <span
            :class="'attendance-icon pull-right ' + getIcon(action_1) + ' fa-2x'"
            style="margin-right:10px; padding:0px; display:inline-block; color:#dedede;"
          />
          <span
            v-if="action_1 !== action_2"
            :class="'attendance-icon pull-right ' + getIcon(action_2) + ' fa-2x'"
            style="margin-right:10px; padding:0px; display:inline-block;"
          />
        </div>
      </div>

      <div
        class="row attendance-list-row"
        style="background-color: rgb(206, 255, 198);"
      >
        <div class="col-xs-6">
          <div class="awesome-checkbox">
            <div
              class="checkbox checkbox-attendance-list"
              style="margin:0px"
            >
              <input
                id="student_example_2"
                type="checkbox"
                checked
                class="student_checkbox"
                disabled
              >
              <label for="student_example_2"><span>Student 2</span></label>
            </div>
          </div>
        </div>

        <div class="col-xs-6">
          <span
            class="attendance-icon pull-right fa fa-ellipsis-v fa-lg"
            style="margin-top:10px; padding:0px;"
          />
          <span
            :class="'attendance-icon pull-right ' + getIcon(action_1) + ' fa-2x'"
            style="margin-right:10px; padding:0px; display:inline-block;"
          />
          <span
            v-if="action_1 !== action_2"
            :class="'attendance-icon pull-right ' + getIcon(action_2) + ' fa-2x'"
            style="margin-right:10px; padding:0px; display:inline-block; color:#dedede;"
          />
        </div>
      </div>
    </div>

    <button
      type="button"
      class="btn btn-primary pull-right"
      @click="saveSettings"
    >
      {{ trans('core.save') }}
    </button>
  </div>
</template>

<script>

import axios from 'axios'
import RegistrationSettingsExample from './RegistrationSettingsExample.vue'
import toast from '../../../services/toast'
import { defaultErrorMessage } from '@/helpers'

export default {

  name: 'RegistrationSettings',

  components: { RegistrationSettingsExample },

  props: {},

  data () {
    return {
      action_1: null,
      action_2: null,
      settableContexts: {},
      icons: {},
    }
  },

  computed: {},

  watch: {},

  mounted () {
    axios.get(`profile/registration-settings/api`).then((response) => {
      this.settableContexts = response.data.settableContexts
      this.icons = response.data.icons
      this.action_1 = Object.values(this.settableContexts).includes(response.data.action_1) ? response.data.action_1 : 'no_action'
      this.action_2 = Object.values(this.settableContexts).includes(response.data.action_2) ? response.data.action_2 : 'no_action'
    }).catch(error => defaultErrorMessage(error))
  },

  methods: {
    saveSettings () {
      let actions = {
        action_1: this.action_1,
        action_2: this.action_2,
      }
      return axios.post('/profile/registration-settings', actions).then(function (response) {
        if (response.status == 200) {
          toast.success(response.data.message)
        }
      }).catch(error => defaultErrorMessage(error))
    },
    getIcon (context) {
      return this.icons[context]
    },
  },
}
</script>
<style>
    .attendance-list-row {
        border: 1px solid;
        padding: 10px 5px;
        border-color: #ddd;
        margin: 0px !important;
        width: 100%;
    }
</style>
